module.exports = __webpack_public_path__ + "img/Jump Casting4.3992c106.jpg";